import React, { useEffect } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { LogoFull } from '../../assets/icons';

import './ReLogin.scss';
import { isMobileDeviceDetectRegex } from '../../utils/Validations';
import { MobileDeviceDetect } from '../../utils/constant';
import {handleSignupButtonNavigation} from '../../utils/handleLoginSignupRedirection'

const ReLoginOutlet = () => {
  const isMobileDevice = () =>{
    return isMobileDeviceDetectRegex
  };
  useEffect(() => {
    if (isMobileDevice()) {
      window.location.replace(MobileDeviceDetect.MOBILE_DEVICE_DETECT);
    }
  }, []);
  return (
    <div className='relogin'>
      <div className='relogin__header'>
        <div className='header__logo'>
          <Link to={'/'}>
            <LogoFull color='#FFFFFF' verticalAlign='middle' />
          </Link>
        </div>
        <div className='header__note'>
          <span className='hide-mobile mr-4 fz-14'>Don’t have an account?</span>
          <a href='/sign-upAuth' onClick={handleSignupButtonNavigation} className='underline fz-14 fw-600 text-white'>
            Sign up
          </a>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default ReLoginOutlet;
